import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const SkillsetCard = ({ title, data, icon: Icon, count }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});

  const toggleItem = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const toggleAll = () => {
    setIsExpanded(!isExpanded);
    if (!isExpanded) {
      // Expand all items when expanding the main section
      const allExpanded = {};
      data.forEach((_, index) => {
        allExpanded[index] = true;
      });
      setExpandedItems(allExpanded);
    } else {
      // Collapse all items when collapsing the main section
      setExpandedItems({});
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
      {/* Header */}
      <div className="p-4 border-b border-gray-100">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
              <Icon className="w-5 h-5 text-purple-600" />
            </div>
            <div className="flex items-center gap-2">
              <h3 className="text-lg font-bold text-gray-900">{title}</h3>
              {count && (
                <span className="inline-flex items-center ml-1 px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                  {count}
                </span>
              )}
            </div>
          </div>
          <div className="flex items-center">
            <button
              onClick={toggleAll}
              className="p-1 hover:bg-gray-100 rounded transition-colors"
            >
              {isExpanded ? (
                <ChevronUp className="w-5 h-5 text-gray-500" />
              ) : (
                <ChevronDown className="w-5 h-5 text-gray-500" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      {isExpanded && (
        <div className="p-4">
          {data && data.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {data.map((item, index) => (
                <div key={index} className="bg-gray-50 border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                  <button
                    onClick={() => toggleItem(index)}
                    className="w-full text-left flex items-center justify-between mb-2"
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-2 h-2 bg-purple-500 rounded-full flex-shrink-0" />
                      <span className="font-medium text-gray-900">
                        {item.sub_heading || item.title || `Item ${index + 1}`}
                      </span>
                    </div>
                    {expandedItems[index] ? (
                      <ChevronUp className="w-4 h-4 text-gray-500" />
                    ) : (
                      <ChevronDown className="w-4 h-4 text-gray-500" />
                    )}
                  </button>
                  
                  {expandedItems[index] && (
                    <div className="text-gray-600 text-sm leading-relaxed">
                      {item.main_sentence || item.description || item.content || 'No description available'}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500">
              <p>No {title.toLowerCase()} data available</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SkillsetCard;